import React, { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { setBackDropLoader } from "../../../components-old/ComponentsIndex";
import { DisplaySpinnerContext } from "../../../context/DisplaySpinnerContext";
import { RouteGuardContext } from "../../../context/RouteGuardContext";

const AppForm = ({ onSubmit, children, setFormValid }) => {
  const { handleSubmit, formState, reset, clearErrors } = useFormContext();
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const routeGuardContext = useContext(RouteGuardContext);

  const { isDirty, isSubmitted } = formState;

  useEffect(() => {
    routeGuardContext.setFormState(isDirty && !isSubmitted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty, isSubmitted]);

  const handleAppFormSubmit = (data) => {
    onSubmit(data, { formState, reset, clearErrors });
  };

  // Keep track of form validity and pass it to parent
  useEffect(() => {
    if (typeof setFormValid === "function") {
      setFormValid(formState.isValid); // Pass validity to parent via prop
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.isValid, setFormValid]);

  return (
    <Box component="form" onSubmit={handleSubmit(handleAppFormSubmit)} noValidate>
      {setBackDropLoader(spinnerCtx.isLoading)}
      {children}
    </Box>
  );
};

export default AppForm;
